import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/stock-adjustments', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/stock-adjustments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/stock-adjustments/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/stock-adjustments/${data.stock_adjustment_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/stock-adjustments/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getProduct = (Option = {}) => {
  return httpClient
    .get(
      '/api/products?perPage=-1&fields[setup_inventory_products]=product_id,product_name_en,uom_cat_id,barcode'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getUOM = (Option = {}) => {
  return httpClient
    .get(
      '/api/unit-of-measures?include=unit_of_measures&fields[unit_of_measures]=uom_cat_id,uom_id,uom_name_en,is_default&perPage=-1'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSystemQty = (product_id, Option = {}) => {
  return httpClient
    .get(`/api/stock-adjustments/system-quantities/${product_id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getProduct,
  getSystemQty,
  getUOM
}
